export default __webpack_public_path__ + "static/media/sequenceShared3.af6462ba.png";